import React, { useState } from 'react'
import { Tabs, Tab, Container } from 'react-bootstrap'
import { colors, breakpoints } from 'globalStyles'
import useDetectTablet from 'hooks/useDetectTablet'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { ReactComponent as CircleIcon } from 'assets/svg/circle.svg'

const StyledContainer = styled(Container)`
  li.nav-item {
    min-width: 98px;
    min-height: 55px;

    @media only screen and ${breakpoints.tablet} {
      min-width: 190px;
    }
    @media only screen and ${breakpoints.desktop} {
      min-width: 330px;
    }
  }
  .nav-underline .nav-link.active {
    border-bottom-color: ${colors.primary_blue};
  }
`

const HorizontalLine = styled.hr`
  width: 100%;
  border: 0;
  border: 3px solid ${colors.web_light_grey};
  margin-top: -3.5px;
`

const iconStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
}

const circleIconStyle = {
  width: '8px',
  height: '8px',
  marginLeft: '5px',
  color: colors.primary_red,
}
const TabsComponent = ({ tabItems, defaultActiveTab, hasToDoTasks }) => {
  const [activeTab, setActiveTab] = useState(defaultActiveTab)

  const isTablet = useDetectTablet()

  const handleSelect = (key) => {
    setActiveTab(key)
  }

  const getTabStyle = (tabKey) => {
    return {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      color: activeTab === tabKey ? colors.text_link_hover : colors.heather_grey,
      fontWeight: activeTab === tabKey ? '600px' : '400px',
      fontSize: isTablet ? '16px' : '13px',
      lineHeight: '18px',
    }
  }

  return (
    <StyledContainer>
      <Tabs activeKey={activeTab} onSelect={handleSelect} variant="underline" justify>
        {tabItems.map((tab) => (
          <Tab
            key={tab.tabKey}
            eventKey={tab.tabKey}
            title={
              <div
                style={{
                  ...getTabStyle(tab.tabKey),
                }}
              >
                <div style={{ iconStyle }}>
                  <tab.tabIcon style={tab.tabIconStyle} />
                  {!hasToDoTasks && tab.showDotIcon && <CircleIcon style={circleIconStyle} />}
                </div>
                {tab.tabTitle}
              </div>
            }
          >
            <HorizontalLine />
            {activeTab === tab.tabKey && tab.component}
          </Tab>
        ))}
      </Tabs>
    </StyledContainer>
  )
}

const tabItemsPropTypes = PropTypes.shape({
  tabKey: PropTypes.string,
  tabTitle: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  component: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  tabIcon: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  tabIconStyle: PropTypes.object,
  showDotIcon: PropTypes.bool,
})

TabsComponent.propTypes = {
  tabItems: PropTypes.arrayOf(tabItemsPropTypes).isRequired,
  defaultActiveTab: PropTypes.string.isRequired,
  hasToDoTasks: PropTypes.bool,
}

TabsComponent.defaultProps = {
  hasToDoTasks: false,
}

export default TabsComponent
